import type { RestGetVivaTransactions } from "@KassaroAB/shared/types/paymentMethods/vivaTransactions";
import type { PaymentMethodId, StoreId } from "@KassaroAB/shared/types/ids";
import { api } from "../utils/api";

export const getVivaTransactionsApi = async (
  storeId: StoreId,
  paymentMethodId: PaymentMethodId,
  date: string,
): Promise<RestGetVivaTransactions> => {
  const params = new URLSearchParams({ date });
  return api.get(
    `stores/${storeId}/paymentMethods/${paymentMethodId}/viva/transactions?${params.toString()}`,
  );
};
